import "@vaadin/accordion";
import "@vaadin/app-layout";
import "@vaadin/app-layout/vaadin-drawer-toggle";
import "@vaadin/button";
import "@vaadin/checkbox";
import "@vaadin/combo-box";
import "@vaadin/custom-field";
import "@vaadin/dialog";
import "@vaadin/form-layout";
import "@vaadin/grid";
import "@vaadin/icon";
import "@vaadin/icon/vaadin-iconset";
import "@vaadin/item";
import "@vaadin/list-box";
import "@vaadin/menu-bar";
import "@vaadin/notification";
import "@vaadin/radio-group/vaadin-radio-button";
import "@vaadin/radio-group/vaadin-radio-group";
import "@vaadin/select";
import "@vaadin/split-layout";
import "@vaadin/tabs";
import "@vaadin/text-area";
import "@vaadin/text-field";
import "@vaadin/vaadin-lumo-styles";
import "@vaadin/context-menu";
import React from "react";
import "./App.css";

import { AppStateProvider } from "./";

import { GlobalContextProvider } from "@vrf/fr-vrf-core-react";
import { router } from "./AppContent";
import { RouterProvider } from "react-router-dom";

export function App() {
  // const navbarStyle = {height: '64px'};
  return (
    <GlobalContextProvider>
      <AppStateProvider>
        <RouterProvider router={router} />
      </AppStateProvider>
    </GlobalContextProvider>
  );
}
